<template>
	<div class="odd-labels" v-if="!onlyHeader">

		<template v-if="!onlyHeader">

		</template>
		<template v-if="ou">
			<template v-if="!ou.sp">
				<template v-if="ou.odd">
					<div class="" v-if="odd" v-for="odd in ou.odd" :class="(findByKey(selectedOdds, 'oddId', odd.id)) ? 'active' : ''">
						<a v-on:click="addBet(odd, {name: ou.name}, match)" :class="'man'+odd.change">
							<template v-if="odd.active && odd.odd !== '1.00'"">
								{{ Number(odd.odd).toFixed(2) }}
							</template>
							<template v-if="!odd.active || odd.odd === '1.00'">
								<i class="icon-lock"></i>
							</template>
						</a>
					</div>
			</template>
		</template>
		</template>
	</div>
</template>


<script>

    export default {
        name: 'winOdds',
        props: {
            market: {
                type: Number,
                default: 1
            },
	        onlyHeader: false,
            odds: {},
            match: {}
        },
        data () {
            return {
                t: this.$root.t,
                selectedOdds: [],
	            ou: {},
                markets: [
                     1, 6
                ]
            }
        },
        mounted () {
            var self = this;

            self.fetchSelectedBets();

            this.$bus.$on('addBet', ($event) => {

                self.selectedOdds = $event;

            })

	        this.checkSpecialValue()

        },
        methods: {
            checkSpecialValue () {
                var self = this;
                Object.keys(this.odds).forEach(function(key) {

                    if(self.markets.indexOf(self.odds[key].market) !== -1){

                        self.ou = self.odds[key];
                    }
                });
            },
            fetchSelectedBets () {
                var self = this;
                this.$getItem('bets', function (key, value) {
                    //console.log all the kay/value pairs

                    self.selectedOdds = value;

                }, function (err) {
                    self.updateBets([])
                })
            },
        }
    }
</script>

<style scoped>
	.odd-labels {
		flex: 1 1 0%;
		display: flex;
		align-items: center;
		justify-content: space-between;
		border-right: 5px solid #e5e5e5;
	}
	.odd-labels div {
		osition: relative;
		display: flex;
		align-items: center;
		justify-content: center;
		height: 100%;
		flex: 1;
		font-weight: bold;
		font-size: 11px
	}
	.odd-labels a {
		float: left;
		width: 100%;
		height: 100%;
		display: flex;
		text-align: center;
		justify-content: center; /* align horizontal */
		align-items: center;
	}
	.odd-labels .active a {
		background: #047bf8 !important;
		color: #fff
	}
	.event-item .odd-labels div {
	}
	.color-scheme-dark .event-item .odd-labels div {
		background-image: linear-gradient(180deg, #273048, #303950);
	}
	.mandown {
		background: linear-gradient(45deg, rgba(255,0,4,1) 0%,rgba(255,23,27,1) 9%,rgba(255,26,30,0) 10%,rgba(255,255,255,0)) !important; /* W3C, IE10+, FF16+, Chrome26+, Opera12+, Safari7+ */
	}
	.manup {
		background: linear-gradient(45deg, rgba(255,255,255,0) 0%,rgba(25,181,59,0) 90%,rgba(23,180,57,1) 91%,rgba(0,173,37,1) 100%) !important;
	}
</style>



// WEBPACK FOOTER //
// src/components/stats/odds/winOdds.vue